//LL: 20.07.20:  copy from common/application

import ParameterFieldBase, { IParameterFieldBaseOptions } from './ParameterFieldBase';

import { EntityColorSelect as EditComponent } from '../tsx/EntityColorSelect';

export class EntityColorSelect extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];

    public static EditComponent = EditComponent;

    public getDefaultOptions() {
        return {
            noTitle: true
        };
    }

    constructor(glob, title: string, validators?: any, defaultVal?: any, options?) {
        //if (defaultVal == null) {
        //    defaultVal = AttributesListField.getDefaultValue();
        //}

        //LL: 20.07.20:  rem
        //AttrQueryStore.init(glob);

        super(glob, title, EntityColorSelect.defaultValidators, validators, defaultVal, options);
    }
}
